import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const SliderWrapper = styled.div`
  max-width: 294px;
  min-height: 50px;
  margin: 50px auto 0px;
`

const SliderContainer = styled.div`
  width: 100%;
  max-width: 280px;
  height: 9px;
  position: relative;
`;

const SliderTrack = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #1ACF21 0%, #FFED4D 30.05%, #FF7E07 68.21%, #F00 100%);
  width: 105%;
  transition: width 3s ease;
  border-radius: 25px;
`;

const DisabledHandle = styled.div`
  width: 19px;
  height: 19px;
  position: absolute;
  top: -5px;
  left: ${props => props.position}%;
  border: 5px solid #ffffff;
  border-radius: 50%;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.23));
  transition: left 2s ease;
`;

const TextValue = styled.div`
  position: absolute;
  width: 45px;
  height: 26px;
  top: -36px;
  left: calc(${props => props.position}% - 13px);
  display: ${props => (props.isVisible ? 'block' : 'none')};
  background-image: url('../assets/trivia/messageValue.svg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${(props) => props.theme.fontSizes.font12};
  color: ${(props) => props.theme.colors.colorWhite};
  > span {
    position: absolute;
    top: 3px;
    left: 11px;
  }
`;

const RiskValuesList = styled.div`
  display: flex;
  justify-content: space-between;
  width: 104%;
  max-width: 300px;
  margin-top: 10px;
`

const ValueItem = styled.div`
  color: ${(props) => props.theme.colors.colorText};
  font-weight: ${(props) => props.theme.fontWeights.extraLight};
  font-size: ${(props) => props.theme.fontSizes.font12};
`

const AppRangeSlider = ({ value }) => {
  const {t} = useTranslation();
  const [position, setPosition] = useState(0);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    setPosition(value);
    setShowText(false);
  }, [value]);

  const RiskValues = useMemo(() => {
    return [
      t("low"),
      t("moderate"),
      t("significant"),
      t("high"),
    ];
  }, [t]);

  useEffect(() => {
    const handleAnimationEnd = () => {
      setShowText(true);
    };

    document.addEventListener('transitionend', handleAnimationEnd);

    return () => {
      document.removeEventListener('transitionend', handleAnimationEnd);
    };
  }, []);
  const renderValue = (val , ind) => (
    <ValueItem key={ind}>{val}</ValueItem>
  )
  return (
    <SliderWrapper>
      <SliderContainer>
        <SliderTrack />
        <DisabledHandle position={position} />
        <TextValue position={position} isVisible={showText}>
          <span>{value}%</span>
        </TextValue>
        <RiskValuesList>{RiskValues.map(renderValue)}</RiskValuesList>
      </SliderContainer>
    </SliderWrapper>
  );
};

export default AppRangeSlider;